import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CHECKIN_ACCEPTANCE_RESULT_STORE_NAME, CheckinAcceptanceResultState } from './checkin-acceptance-result.state';

/** Select CheckinAcceptanceResult State */
export const selectCheckinAcceptanceResultState = createFeatureSelector<CheckinAcceptanceResultState>(
  CHECKIN_ACCEPTANCE_RESULT_STORE_NAME
);

/** Select CheckinAcceptanceResult isPending status */
export const selectCheckinAcceptanceResultIsPendingStatus = createSelector(
  selectCheckinAcceptanceResultState,
  (state) => !!state.isPending
);

/** Select CheckinAcceptanceResult isFailure status */
export const selectCheckinAcceptanceResultIsFailureStatus = createSelector(
  selectCheckinAcceptanceResultState,
  (state) => !!state.isFailure
);

export const selectCheckinAcceptanceResult = createSelector(
  selectCheckinAcceptanceResultState,
  (state) => state.checkinAcceptanceResult
);
